export enum SystemRole {
  BACKOFFICE_VIEWER = 'backoffice_viewer',
  BACKOFFICE_AGENT = 'backoffice_agent',
  BACKOFFICE_BILLING_ADMIN = 'backoffice_billing_admin',
  BACKOFFICE_ADMIN = 'backoffice_admin',
}

export const SYSTEM_ROLE_RANK: Readonly<Record<SystemRole, number>> = {
  [SystemRole.BACKOFFICE_VIEWER]: 1,
  [SystemRole.BACKOFFICE_AGENT]: 2,
  [SystemRole.BACKOFFICE_BILLING_ADMIN]: 3,
  [SystemRole.BACKOFFICE_ADMIN]: 4,
};

export const SYSTEM_ROLE_NONE = 'none';

export const SYSTEM_ROLE_OPTIONS: readonly SystemRole[] = [
  SystemRole.BACKOFFICE_VIEWER,
  SystemRole.BACKOFFICE_AGENT,
  SystemRole.BACKOFFICE_BILLING_ADMIN,
  SystemRole.BACKOFFICE_ADMIN,
];

export const SYSTEM_ROLE_LABEL: Readonly<Record<SystemRole, string>> = {
  [SystemRole.BACKOFFICE_VIEWER]: 'backoffice.enums.system_role.backoffice_viewer',
  [SystemRole.BACKOFFICE_AGENT]: 'backoffice.enums.system_role.backoffice_agent',
  [SystemRole.BACKOFFICE_BILLING_ADMIN]: 'backoffice.enums.system_role.backoffice_billing_admin',
  [SystemRole.BACKOFFICE_ADMIN]: 'backoffice.enums.system_role.backoffice_admin',
};
